/* Outlecta UI v2: rörelse och beteenden för .ox-sektioner.
   All rörelse är avstängd vid prefers-reduced-motion och i temaredigeraren.
   Smooth scroll: Lenis (MIT, laddas från jsDelivr i outlecta-global.liquid). */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var motion = !reduce && !editor;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var lenis = null;

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* ---------- Gemensam scrollbuss (en rAF per scrollhändelse) ---------- */
  var subs = [], queued = false;
  function onScroll(fn) { subs.push(fn); }
  function frame() {
    queued = false;
    var y = window.pageYOffset, vh = window.innerHeight;
    for (var i = 0; i < subs.length; i++) subs[i](y, vh);
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);

  /* ---------- Lenis: mjuk musscroll (av på touch och vid reducerad rörelse) ---------- */
  function initLenis() {
    if (!motion || !fine || !window.Lenis || window.lenis) return;
    lenis = new window.Lenis({ lerp: 0.09, smoothWheel: true, syncTouch: false });
    window.lenis = lenis;
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    /* Dawn låser sidan med overflow-hidden när varukorg, meny eller sök är öppna */
    function syncLock() { if (/overflow-hidden/.test(document.body.className)) lenis.stop(); else lenis.start(); }
    new MutationObserver(syncLock).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('cart-drawer, .cart-drawer, .menu-drawer, predictive-search, .predictive-search, [role="dialog"], .modal__content').forEach(function (el) { el.setAttribute('data-lenis-prevent', ''); });
    syncLock();
  }

  /* ---------- Scrollframsteg högst upp ---------- */
  function initProgressBar() {
    if (!motion || document.querySelector('.ox-progressbar')) return;
    var bar = document.createElement('div');
    bar.className = 'ox-progressbar'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    onScroll(function (y, vh) {
      var max = root.scrollHeight - vh;
      bar.style.transform = 'scaleX(' + (max > 0 ? clamp(y / max, 0, 1) : 0).toFixed(4) + ')';
    });
  }

  /* Headerns höjd, så pinnade scener inte hamnar under en klibbig header */
  function setHeaderH() {
    var sticky = document.querySelector('.shopify-section-header-sticky');
    var h = sticky ? sticky.getBoundingClientRect().height : 0;
    root.style.setProperty('--ox-header-h', Math.round(h) + 'px');
  }
  window.addEventListener('resize', setHeaderH);

  /* ---------- Hero: radvis rubrik, rundade hörn och parallax vid scroll ---------- */
  function splitHeading(h) {
    if (h.dataset.oxSplit) return;
    var text = h.textContent.trim().replace(/\s+/g, ' ');
    h.setAttribute('aria-label', text);
    h.textContent = '';
    text.split(' ').forEach(function (word, i) {
      var o = document.createElement('span'); o.className = 'ox-w'; o.setAttribute('aria-hidden', 'true');
      var s = document.createElement('span'); s.style.setProperty('--ox-i', i); s.textContent = word;
      o.appendChild(s); h.appendChild(o); h.appendChild(document.createTextNode(' '));
    });
    h.dataset.oxSplit = '1';
  }
  function initHero(hero) {
    if (hero.dataset.oxReady) return; hero.dataset.oxReady = '1';
    if (!motion) return;
    var h1 = hero.querySelector('h1'); if (h1) splitHeading(h1);
    var layers = [].slice.call(hero.querySelectorAll('[data-ox-parallax]'));
    onScroll(function () {
      var r = hero.getBoundingClientRect(), past = -r.top, hh = hero.offsetHeight;
      if (past > hh + 120) return;
      var p = clamp(past / (hh * 0.6), 0, 1);
      hero.style.setProperty('--ox-hero-r', (p * 56).toFixed(1) + 'px');
      hero.style.setProperty('--ox-hero-fade', (1 - p * 0.6).toFixed(3));
      layers.forEach(function (el) { el.style.setProperty('--ox-py', (Math.max(0, past) * parseFloat(el.dataset.oxParallax)).toFixed(1) + 'px'); });
    });
  }

  /* Hero: roterande testprotokoll */
  function initBench(rootEl) {
    if (rootEl.dataset.oxReady) return; rootEl.dataset.oxReady = '1';
    var tags = rootEl.querySelectorAll('.ox-tag');
    var dots = rootEl.querySelectorAll('.ox-bench__dots button');
    if (!tags.length) return;
    var i = 0, timer = null, ms = parseInt(rootEl.dataset.interval, 10) || 5200;
    function show(n) {
      var prev = tags[i];
      prev.classList.remove('is-active'); prev.classList.add('is-leaving');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 700);
      i = (n + tags.length) % tags.length;
      tags[i].classList.add('is-active');
      tags.forEach(function (t, k) { t.setAttribute('aria-hidden', k === i ? 'false' : 'true'); t.tabIndex = k === i ? 0 : -1; });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function start() { if (reduce || tags.length < 2) return; stop(); timer = setInterval(function () { show(i + 1); }, ms); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    rootEl.addEventListener('mouseenter', stop); rootEl.addEventListener('mouseleave', start);
    rootEl.addEventListener('focusin', stop); rootEl.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    tags[0].classList.add('is-active');
    tags.forEach(function (t, k) { if (k) { t.setAttribute('aria-hidden', 'true'); t.tabIndex = -1; } });
    start();
  }

  /* ---------- Siffror som räknas upp när de kommer i bild ---------- */
  function initCounters(scope) {
    var els = scope.querySelectorAll('[data-ox-count]:not([data-ox-done])');
    if (!els.length) return;
    if (!motion || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.dataset.oxDone = '1'; }); return; }
    function run(el) {
      var to = parseFloat(el.dataset.oxCount); if (!isFinite(to)) return;
      var t0 = null, dur = 1500;
      function step(t) {
        if (t0 === null) t0 = t;
        var k = clamp((t - t0) / dur, 0, 1), e = k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
        el.textContent = Math.round(to * e);
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (e) { e.dataset.oxDone = '1'; e.textContent = '0'; io.observe(e); });
  }

  /* ---------- Processen: pinnad scen på desktop, scrollstyrd lista annars ---------- */
  function initProcess(rootEl) {
    if (rootEl.dataset.oxReady) return; rootEl.dataset.oxReady = '1';
    var stage = rootEl.querySelector('.ox-process__stage');
    var list = rootEl.querySelector('.ox-steps'); if (!list || !stage) return;
    var steps = [].slice.call(list.querySelectorAll('.ox-step'));
    var ticks = [].slice.call(rootEl.querySelectorAll('.ox-process__ticks button'));
    var now = rootEl.querySelector('[data-ox-now]');
    var mq = window.matchMedia('(min-width: 1100px)');
    var pinned = false, active = -1;
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function setActive(i) {
      if (i === active) return;
      var first = active === -1; active = i;
      steps.forEach(function (s, k) {
        s.dataset.state = k === i ? 'active' : (k < i ? 'prev' : 'next');
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      ticks.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (now) {
        now.textContent = pad(i + 1);
        if (!first && now.animate) now.animate([{ transform: 'translateY(35%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 600, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
    }
    function listUpdate(vh) {
      var r = list.getBoundingClientRect();
      rootEl.style.setProperty('--ox-progress', clamp((vh * 0.6 - r.top) / r.height, 0, 1).toFixed(3));
      steps.forEach(function (s) { s.classList.toggle('is-on', s.getBoundingClientRect().top < vh * 0.62); });
    }
    function update(y, vh) {
      if (!pinned) { if (motion) listUpdate(vh); return; }
      var span = stage.offsetHeight - vh; if (span <= 0) return;
      var p = clamp(-stage.getBoundingClientRect().top / span, 0, 1);
      rootEl.style.setProperty('--ox-progress', p.toFixed(4));
      var raw = p * steps.length, cand = clamp(Math.floor(raw), 0, steps.length - 1);
      if (active !== -1 && cand !== active) {
        var edge = cand > active ? cand : cand + 1;
        if (Math.abs(raw - edge) < 0.06) return; /* hysteres: ingen fladder på gränsen */
      }
      setActive(cand);
    }
    function mode() {
      var want = motion && mq.matches;
      pinned = want;
      rootEl.classList.toggle('is-pinned', pinned);
      steps.forEach(function (s) { s.removeAttribute('data-state'); s.removeAttribute('aria-hidden'); });
      active = -1;
      if (pinned) { setActive(0); }
      else if (!motion) { steps.forEach(function (s) { s.classList.add('is-on'); }); rootEl.style.setProperty('--ox-progress', 1); }
      schedule();
    }
    ticks.forEach(function (t, k) {
      t.addEventListener('click', function () {
        var span = stage.offsetHeight - window.innerHeight;
        var top = stage.getBoundingClientRect().top + window.pageYOffset + ((k + 0.5) / steps.length) * span;
        if (lenis) lenis.scrollTo(top, { duration: 1.1 }); else window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if (mq.addEventListener) mq.addEventListener('change', mode); else if (mq.addListener) mq.addListener(mode);
    onScroll(update);
    mode();
  }

  /* ---------- Kategorikort: bilderna glider i olika takt mot scrollen ---------- */
  var catsBound = false;
  function initCats() {
    if (!motion || catsBound || !document.querySelector('.ox-cat')) return;
    catsBound = true;
    onScroll(function (y, vh) {
      document.querySelectorAll('.ox-cat').forEach(function (c) {
        var r = c.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return;
        c.style.setProperty('--ox-pd', clamp((r.top + r.height / 2 - vh / 2) / vh, -1.2, 1.2).toFixed(3));
      });
    });
  }

  /* ---------- Magnetiska knappar (endast mus) ---------- */
  function initMagnet(scope) {
    if (!motion || !fine) return;
    scope.querySelectorAll('.ox-btn:not([data-ox-mag])').forEach(function (b) {
      b.dataset.oxMag = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width, dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        b.style.translate = (dx * 10).toFixed(1) + 'px ' + (dy * 8).toFixed(1) + 'px';
      });
      b.addEventListener('pointerleave', function () { b.style.translate = ''; });
    });
  }

  /* ---------- Reveal med stagger ---------- */
  /* Dawns egna element och våra rubriker märks automatiskt, men bara de som ligger under vecket. */
  var AUTO = [
    ['.featured-collection .title-wrapper-with-link, .featured-collection .title', false],
    ['.featured-collection .product-grid > li', true],
    ['.collapsible-content .title, .collapsible-content h2', false],
    ['.collapsible-content .accordion', true],
    ['.ox-h2', false]
  ];
  function autoTag(scope) {
    var vh = window.innerHeight;
    AUTO.forEach(function (rule) {
      scope.querySelectorAll(rule[0]).forEach(function (el, idx) {
        if (el.classList.contains('ox-reveal') || el.closest('.scroll-trigger, .ox-reveal')) return;
        if (el.getBoundingClientRect().top < vh * 0.92) return;
        el.classList.add('ox-reveal');
        if (rule[1]) el.style.setProperty('--ox-d', ((idx % 5) * 80) + 'ms');
      });
    });
  }
  function initReveal(scope) {
    var els = scope.querySelectorAll('.ox-reveal:not(.is-in)');
    if (!motion || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Bildbeskärning, slutsålda sist, långa beskrivningar (oförändrat) ---------- */
  /* Mobilskärmdumpar (1179×2556 / 2556×1179) har svarta fält runt fotot: beskär till mitten */
  var CROP_SEL = '.card__media img, .ox-cat__stack img, .ox-tag__media img, .product__media img';
  function checkShot(img) {
    var w = img.naturalWidth, h = img.naturalHeight; if (!w || !h) return;
    var r = Math.max(w, h) / Math.min(w, h);
    if (!(r > 2.05 && r < 2.3)) return;
    img.classList.add('ox-crop');
    /* Produktgalleriet: ramen följer bildens format, sätt den till fotots 4:3 / 3:4 så fälten försvinner */
    var c = img.closest('.product-media-container');
    if (c) { var fr = w > h ? '1.3333' : '0.75'; c.style.setProperty('--ratio', fr); c.style.setProperty('--preview-ratio', fr); }
  }
  function markScreenshots(scope) {
    scope.querySelectorAll(CROP_SEL).forEach(function (img) { if (img.complete) checkShot(img); });
  }
  /* Fångar även bilder som laddas senare (lazy load, filter, "visa fler") */
  document.addEventListener('load', function (e) {
    var t = e.target; if (t.tagName === 'IMG' && t.matches(CROP_SEL)) checkShot(t);
  }, true);

  /* Slutsålda produkter sist i varje produktrutnät (kollektion, sök, utvalda) */
  function sinkSoldOut(scope) {
    scope.querySelectorAll('ul.product-grid, #product-grid').forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.children), sold = [], seenSold = false, needsMove = false;
      items.forEach(function (li) {
        var b = li.querySelector('.card__badge .badge, .card__badge');
        var isSold = !!(b && /sold out|slutsåld/i.test(b.textContent));
        if (isSold) { li.classList.add('ox-soldout'); sold.push(li); seenSold = true; }
        else if (seenSold) { needsMove = true; } /* ett tillgängligt kort efter ett slutsålt */
      });
      if (needsMove) sold.forEach(function (li) { grid.appendChild(li); });
    });
  }
  /* Filter/sortering byter ut rutnätet via AJAX, kör igen när det händer */
  var gridHost = document.getElementById('ProductGridContainer');
  if (gridHost && 'MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; sinkSoldOut(gridHost); markScreenshots(gridHost); });
    }).observe(gridHost, { childList: true, subtree: true });
  }

  /* Lång kollektionsbeskrivning: visa början, "Read more" fäller ut */
  function clampDescriptions(scope) {
    scope.querySelectorAll('.collection-hero__description').forEach(function (d) {
      if (d.dataset.oxClamp || d.scrollHeight < 190) return;
      d.dataset.oxClamp = '1'; d.classList.add('ox-desc-clamp'); d.id = d.id || 'ox-desc';
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'ox-desc-toggle'; btn.textContent = 'Read more';
      btn.setAttribute('aria-controls', d.id); btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = d.classList.toggle('ox-desc-clamp') === false;
        btn.textContent = open ? 'Show less' : 'Read more'; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      d.insertAdjacentElement('afterend', btn);
    });
  }

  function init(scope) {
    scope = scope || document;
    markScreenshots(scope);
    sinkSoldOut(scope);
    clampDescriptions(scope);
    scope.querySelectorAll('[data-ox-bench]').forEach(initBench);
    scope.querySelectorAll('.ox-hero').forEach(initHero);
    scope.querySelectorAll('[data-ox-process]').forEach(initProcess);
    initCounters(scope);
    initCats();
    initMagnet(scope);
    if (motion) autoTag(scope);
    initReveal(scope);
  }

  function boot() {
    setHeaderH();
    initLenis();
    initProgressBar();
    init();
    schedule();
    /* Först nu visas startanimationerna: initiala lägen är redan målade */
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('ox-ready'); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Temaeditorn laddar om sektioner live */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
